import React from 'react';
import { FacebookIcon, TwitterIcon } from 'react-share';
import { Typography } from '@pwskills/rachnaui';
import { Linkedin } from '@pwskills/rachnaui/Icons';
import { IcertificateDetails } from '../../TypesAndInterfaces';
import DownloadButtons from './DownloadButtons';

interface CertificateSidebarProps {
  certificateDetails: IcertificateDetails;
  allCertificates: IcertificateDetails[];
  isCareerPath: boolean;
  selectedIndex: number;
  onLinkedInShare: () => void;
  onFacebookShare: () => void;
  onTwitterShare: () => void;
}

const CertificateSidebar: React.FC<CertificateSidebarProps> = ({
  certificateDetails,
  allCertificates,
  isCareerPath,
  selectedIndex,
  onLinkedInShare,
  onFacebookShare,
  onTwitterShare,
}) => {
  return (
    <div className="w-[100%] large:!w-[30%] bg-white rounded-2 shadow-[0_0_10px_rgba(162, 182, 235, 0.15)] px-[10px] medium:!px-[42px] py-[36px]">
      <div className="flex flex-col w-full">
        <div className="mb-4">
          <Typography component="h4" variant="bold">
            Recipient:
          </Typography>
        </div>
        <div className="mb-4">
          <Typography
            component="body-regular"
            variant="semi-bold"
            className="text-[#3D3D3D] !break-words"
          >
            {certificateDetails?.userDetails?.firstName} {certificateDetails?.userDetails?.lastName}
          </Typography>
        </div>
        <div className="mb-5">
          <Typography component="body-small" variant="regular" className="text-[#757575]">
            Issue Date: {certificateDetails?.certificate?.dateCompleted}
          </Typography>
        </div>
        <div className="mb-4">
          <Typography component="body-regular" variant="semi-bold" className="text-[#757575]">
            Share
          </Typography>
        </div>

        <div className="flex gap-5">
          <button
            type="button"
            onClick={onLinkedInShare}
            aria-label="Share on LinkedIn"
            className="bg-[#DEF3FE] rounded-[50%] flex justify-center items-center px-[12px] py-[10px] cursor-pointer"
          >
            <Linkedin className="text-[#0077B5] relative" />
          </button>
          <button
            type="button"
            onClick={onFacebookShare}
            aria-label="Share on Facebook"
            className="bg-[#DCE7FF] rounded-[50%] flex justify-center items-center px-[10px] cursor-pointer"
          >
            <FacebookIcon size={25} round />
          </button>
          <button
            type="button"
            onClick={onTwitterShare}
            aria-label="Share on Twitter"
            className="bg-[#E2F6FF] rounded-[50%] flex justify-center items-center cursor-pointer"
          >
            <TwitterIcon size={46} bgStyle={{ display: 'none' }} iconFillColor="#03A9F4" />
          </button>
        </div>
      </div>
      <DownloadButtons
        certificateDetails={certificateDetails}
        allCertificates={allCertificates}
        isCareerPath={isCareerPath}
        selectedIndex={selectedIndex}
      />
    </div>
  );
};

export default CertificateSidebar;
